import { render, staticRenderFns } from "./previous-button.vue?vue&type=template&id=1582e22c&"
import script from "./previous-button.vue?vue&type=script&lang=js&"
export * from "./previous-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports